import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
`
export const ChaptersList = styled.div`
  display: flex;
  flex-direction: column;
`
